import axios, { AxiosInstance } from "axios";

export class OldAuthRestClient {
  private url: string;
  public client: AxiosInstance;

  constructor(url: string) {
    this.url = url;
    this.createClient();
  }

  public createClient() {
    const client = axios.create({
      baseURL: this.url,
    });

    client.defaults.headers["Content-Type"] = "application/json; charset=utf-8";
    client.defaults.headers.Accept = "application/json; charset=utf-8";

    this.client = client;
  }

  public login(username: string, password: string): Promise<any> {
    return this.client.post("/login", {
      email: username,
      password: password,
    });
  }

  public fetchUser(token: string): Promise<any> {
    return this.client.get("/me", {
      headers: {
        Authorization: token,
      },
    });
  }
}
